<template>
    <MonitoringView v-if="initialized"></MonitoringView>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api";
import ReportModule from "../../store/modules/report";
import MonitoringView from "@/views/Monitoring/MonitoringView.vue";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default {
    name: "MonitoringWrapper",
    components: {
        MonitoringView
    },
    setup() {
        const initialized = ref(false);
        const { fetchReportFilters } = ReportModule();

        onMounted(async () => {
            try {
                await fetchReportFilters()
                initialized.value = true;
            } catch (e) {
                errorDialog.showError(e);
            }
        })

        return {
            initialized
        };
    }
};
</script>
